import { getFirestore, collection, addDoc } from "firebase/firestore";

interface FeedbackData {
  conversationId: string;
  messageId: string;
  type: "good" | "bad";
  details?: string;
  timestamp: Date;
}

export const feedbackService = {
  async submitFeedback(data: FeedbackData) {
    const db = getFirestore();
    const feedbackRef = collection(db, "messageFeedback");
    await addDoc(feedbackRef, {
      ...data,
      timestamp: new Date(),
    });
  },

  async submitGoodFeedback(conversationId: string, messageId: string) {
    return this.submitFeedback({
      conversationId,
      messageId,
      type: "good",
      timestamp: new Date(),
    });
  },

  async submitBadFeedback(
    conversationId: string,
    messageId: string,
    details: string
  ) {
    return this.submitFeedback({
      conversationId,
      messageId,
      type: "bad",
      details,
      timestamp: new Date(),
    });
  },
};
